import { SnackbarProvider } from 'notistack';
import { SnackbarCloseButton } from './SnackbarCloseButton';

function NotificationProvider({ children }: { children: React.ReactNode }) {
    return (
        <SnackbarProvider
            maxSnack={5}
            autoHideDuration={4000}
            dense
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}
        >
            {children}
        </SnackbarProvider>
    );
}

export default NotificationProvider;
